import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { setHead } from "../lib/head";
import { useSite } from "../context/SiteContext";
import { SectionHead } from "../components/site/Brand";
import { DateRange } from "../components/site/DateRange";

export const PostCard = ({ p, cdn, lazy }) => (
  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
    className="glass-card group flex flex-col overflow-hidden transition-transform hover:-translate-y-1">
    <div className="aspect-[16/9] overflow-hidden bg-[#12141C]">
      {p.featured_image && (
        <img src={fileUrl(p.featured_image, cdn)} alt={p.featured_alt || p.title} loading={lazy ? "lazy" : "eager"}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      )}
    </div>
    <div className="flex flex-1 flex-col p-6">
      <p className="text-xs uppercase tracking-widest text-[#D4AF37]">{new Date(p.published_at || p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</p>
      <h3 className="mt-3 font-serif text-lg font-semibold text-white">{p.title}</h3>
      <p className="mt-2 line-clamp-3 text-sm text-zinc-400">{p.excerpt || p.seo?.meta_description}</p>
      <span className="gold-underline mt-auto w-fit pt-5 text-xs uppercase tracking-widest text-white">Read more</span>
    </div>
  </Link>
);

export default function BlogList() {
  const { site } = useSite();
  const [posts, setPosts] = useState(null);
  const [range, setRange] = useState({ start: "", end: "" });
  const perf = site?.performance;

  useEffect(() => {
    setHead({ title: "Blog | DaddyAnna247 — Cricket & Casino Tips", description: "Guides, cricket betting tips, casino strategies and news from DaddyAnna247.", canonical: `${window.location.origin}/blog` });
  }, []);

  useEffect(() => {
    let live = true;
    const q = new URLSearchParams({ kind: "blog", limit: "60", ...(range.start && { start: range.start }), ...(range.end && { end: range.end }) });
    api.get(`/public/posts?${q}`).then(({ data }) => live && setPosts(data)).catch(() => live && setPosts([]));
    return () => { live = false; };
  }, [range]);

  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="blog-list-page">
      <SectionHead eyebrow="Blog" title="Insights & Guides" sub="Tips, strategies and updates for smarter, responsible play." />
      <div className="mb-10 flex flex-wrap items-center gap-3">
        <span className="text-xs uppercase tracking-widest text-zinc-500">Filter by date</span>
        <DateRange start={range.start} end={range.end} onChange={setRange} testid="blog-date" />
      </div>
      {posts === null ? (
        <p className="text-zinc-500">Loading…</p>
      ) : posts.length === 0 ? (
        <p className="text-zinc-500" data-testid="blog-empty">{range.start || range.end ? "No articles in this date range." : "No articles yet. Check back soon."}</p>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((p) => <PostCard key={p.id} p={p} cdn={perf?.cdn_base_url} lazy={perf?.lazyload !== false} />)}
        </div>
      )}
    </section>
  );
}
